import { useQuery, useQueryClient } from "@tanstack/react-query";
import { usePymbleApi } from "./usePymbleApi";

const ASSETS_END_POINT = "/storage/assets/?subdir=groups/icons";

/**
 * Hook to fetch icons listing from api.
 */
export function useIcons() {
  const { callApi, isAuthenticated } = usePymbleApi();
  const queryClient = useQueryClient();

  const { data: icons = [], isLoading } = useQuery({
    queryKey: ["icons"],
    queryFn: async () => {
      const res = await callApi("GET", ASSETS_END_POINT);
      return res || [];
    },
    enabled: isAuthenticated,
    staleTime: Infinity,
  });

  const refreshIcons = () => {
    queryClient.invalidateQueries({ queryKey: ["icons"] });
  };

  return {
    icons,
    iconsLoaded: !isLoading,
    refreshIcons,
  };
}
